import request from '@/sheep/request';


// 获取小组成员列表
export const getGroupsMemberPage = async (params?: any) => {
	return request({
		url: '/wish/group/members/page',
		method: 'GET',
		params
	});
}

// 禁言
export const mutedGroupMember = async (params?: any) => {
	return request({
		url: '/wish/group/members/muted',
		method: 'GET',
		params,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '禁言成功'
		},
	});
}

// 解除禁言
export const unMutedGroupMember = async (params?: any) => {
	return request({
		url: '/wish/group/members/un-muted',
		method: 'GET',
		params,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '解除禁言成功'
		},
	});
}

// 从小组移除成员
export const removeGroupMember = async (params?: any) => {
	return request({
		url: '/wish/group/members/remove',
		method: 'GET',
		params,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '从小组移除成功'
		},
	});
}
